<template>
  <b-row>
    <StepperCol :step="7" />
    <b-col cols="10" md="11" class="pb-4">
      <div class="d-flex mb-4">
        <h5
          class="h3 font-weight-normal mb-0"
          :class="collapsed ? '' : 'text-muted'"
        >
          コンセントの形状は？
        </h5>
        <b-button @click="helpModalShow = true" variant="link" class="p-0 ml-3">
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 512 512"
            class=""
          >
            <path
              fill="currentColor"
              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
              class=""
            ></path>
          </svg>
        </b-button>
        <b-modal
          centered
          hide-footer
          title="コンセントの形状"
          v-model="helpModalShow"
        >
          <p>
            コンセントの形状がエアコンの電源プラグと異なる場合は、コンセント交換等のオプション工事が別途必要になります。
          </p>
          <ul>
            <li>コンセント交換 3,300円(税込)</li>
            <li>電圧切換 3,300円(税込)</li>
          </ul>
          <p class="text-danger mb-0">
            ※ 本シミュレーターの計算結果には必要有無が加味されません。
          </p>
        </b-modal>
      </div>
      <h5 v-if="skipped" class="text-muted">専用コンセントなし</h5>
      <template v-else>
        <b-collapse v-model="shrinking" class="d-md-none">
          <b-button
            variant="outline-warning"
            size="lg"
            class="btn-gd text-left position-relative py-2"
            block
            @click="shrinking = false"
          >
            <span class="h4 m-0">{{ mobileAnswer }}</span>
            <div class="accessory-shrinking">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 12 12"
              >
                <polyline
                  fill="none"
                  stroke="#FD9000"
                  stroke-width="2"
                  points="0,6 6,11 12,6"
                />
              </svg>
            </div>
          </b-button>
        </b-collapse>
        <b-collapse v-model="isCollapsed">
          <p class="h5 text-muted position-relative pl-4">
            <span class="position-absolute" style="top:0; left:0;">※</span>
            コンセント形状が商品と異なる場合3,300円の追加費用がかかる場合があります<br />
            また、100V↔︎200Vの電圧切替が必要となる場合別途3,300円の追加費用がかかります。
          </p>

          <b-form-row>
            <b-col
              v-for="(question, i) in questions"
              :key="'q6-' + i"
              cols="12"
              md="4"
              class="mb-3"
            >
              <b-button
                class="btn-gd text-left p-0 h-120px"
                :class="selectedAnswer == i ? 'selected' : ''"
                @click="buttonClicked(i)"
              >
                <b-row no-gutters class="h-100">
                  <b-col cols="8" class="pt-3">
                    <h6 class="h4 pt-2 px-3" v-html="question"></h6>
                  </b-col>
                  <b-col cols="4" class="h-100 text-right">
                    <b-img
                      class="img-q6"
                      :src="
                        require('@/assets/images/q5-1-' + (i + 1) + '@2x.png')
                      "
                    ></b-img>
                  </b-col>
                </b-row>
              </b-button>
            </b-col>
          </b-form-row>
        </b-collapse>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      selectedAnswer: null,
      questions: [
        "100V<br>15A 専用<br>並行型",
        "100V<br>20A 専用<br>IL(アイエル)型",
        "100V<br>15/20A 兼用IL(アイエル)型",
        "200V<br>15A 専用<br>タンデム型",
        "200V<br>15/20A 兼用<br>エルバー型",
        "それ以外 / 不明",
      ],
      skipped: false,
      helpModalShow: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 7) {
        this.collapsed = true;
      }
    },
    hasSocket(val, old) { // eslint-disable-line
      if (val == 1) {
        this.skipped = true;
        this.selectedAnswer = 0
      } else {
        this.skipped = false;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      hasSocket() {
        return this.$store.getters.hasSocket;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
    mobileAnswer() {
      if (this.selectedAnswer === null) {
        return "";
      } else {
        return this.questions[this.selectedAnswer].replaceAll("<br>", " ");
      }
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.selectedAnswer = null;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      this.selectedAnswer = value;
      this.doSaveAnswer({ keyword: 'socket_type', answer: value });
      this.doUpdateStep(8);
      this.shrinking = true;
    },
  },
};
</script>

<style>
.img-q6 {
  height: 100%;
  width: auto;
}
</style>